<template>
  <tr ref="row" @click="toggle()" :class="!isLast ? 'border-b border-bdefault' : ''">
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">
      {{ $formatDate(data.evaluationDate) }}
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">{{ data.type }}</td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">
      <img :src="getMoodRatioImage(data.patientComplaint)" class="h-10 w-10" />
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor" v-if="data.type !== 'Evaluation-Spt'">
      {{ data.ahi }}
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor" v-else></td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor" v-if="data.patientsFinalAssessment">
      <span
        class="osa-details-row__status h-6 w-6 rounded-full inline-block mr-2 align-middle"
        :class="getStatusClassName(data.patientsFinalAssessment)"
      ></span>
      {{ data.patientsFinalAssessment }}
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor" v-else></td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor justify-content-end">
      <button
        @click.stop="toggle"
        class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-primary-default bg-white rounded-full hover:bg-primary-default/50 items-center"
      >
        <template v-if="isExpanded"> Toon minder </template>
        <template v-else>Toon meer </template>
      </button>
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded">
    <td class="py-3.5 pl-4 pr-3 text-left text-base" colspan="6">
      <p class="font-bold">Therapietrouw (Uitgelezen gemiddelde over laatste 3 weken)</p>
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails && data.type !== 'Evaluatie-Spt'">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">AHI</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.Ahi }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      Hoeveel uur slaapt patiënt gemiddeld per nacht met het apparaat?:
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.AvgHoursSleep }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      Hoeveel dagen per week slaapt de patiënt gemiddeld met het apparaat?:
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.AvgDaysSleep }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Heeft de patiënt gewenningsproblemen?:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3" v-if="osaRowOverviewDetails.HabituationProblems">Ja</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3" v-else>Nee</td>
  </tr>
  <tr v-if="isExpanded && osaRowOverviewDetails" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Hypersomnolentie:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.Hypersomnolence }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      Hoe voelt de patiënt zich ten opzichte van zijn of haar klachten?:
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.PatientComplaint }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails && osaRowOverviewDetails.PatientComplaintNote">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Opmerking patiënt:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.PatientComplaintNote }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails && osaRowOverviewDetails.PartnerComplaint !== 0">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      Hoe voelt de partner zich ten opzichte van de klachten van de patiënt?:
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.PartnerComplaint }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails && osaRowOverviewDetails.PartnerComplaintNote">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Opmerking partner:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.PartnerComplaintNote }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails && osaRowOverviewDetails.PatientsFinalAssessment">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Eindoordeel patiënt:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.PatientsFinalAssessment }}
    </td>
  </tr>
  <tr v-if="isExpanded && osaRowOverviewDetails" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Opmerkingen evaluatie:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.EvaluationComments }}
    </td>
  </tr>
  <tr ref="row" v-if="getVisibilityStatus()">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="6">
      <p class="font-bold">Instellen apparatuur definitieve aanvraag</p>
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">CPAP</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.Cpap }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Auto CPAP - Min:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.AutoCpapMin }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Auto CPAP - Max:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.AutoCpapMax }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">BiPAP - IPAP:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.Ipap }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">BiPAP - EPAP:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.Epap }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Ramp instelling (minuten):</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.RampSettingsMinutes }}
    </td>
  </tr>
  <tr v-if="getVisibilityStatus()" ref="row">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">Minimale ramp druk:</td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      {{ osaRowOverviewDetails.MinimalDisasterPressure }}
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && data.type === 'Evaluatie'">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      <span>
        <p>Evaluatie gereed voor akkoordverklaring:</p>
        <p class="font-bold">Evaluatie door:</p>
      </span>
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      <span>
        <p class="font-bold">
          <component
            :is="statusIcon"
            :class="{ 'status-active': isApproved, 'status-inactive': !isApproved }"
            class="inline-block mr-2 align-top"
          />
          {{ statusText }}
        </p>
        <p v-if="user" class="font-bold">{{ user.username }}</p>
      </span>
    </td>
  </tr>
  <tr ref="row" v-if="isExpanded && osaRowOverviewDetails">
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      <p class="font-bold">Upload en bekijk recente uitlezingen:</p>
    </td>
    <td class="py-2 pl-4 pr-3 text-left text-base" colspan="3">
      <!-- Documenten button //-->
      <button
        @click.prevent="loadPdfDetails"
        class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-primary-default bg-white rounded-full hover:bg-primary-default/50 items-center"
      >
        <ArrowDownTrayIcon class="h-5 w-5 flex-shrink-0 text-primary-color mr-2" aria-hidden="true" />
        Documenten
      </button>
    </td>
  </tr>
  <generic-modal :hasCloseButton="true" v-if="showPdfDetailsPopUp" @close="closeModal">
    <template #body>
      <div class="row">
        <div class="col-md-6 flex font-bold text-2xl justify-center">Documenten</div>
        <div class="col-md-6 grid-align-end" v-if="!showUploadedFiles">
          <button
            @click.prevent="openCompactFileUpload"
            class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-primary-default bg-white rounded-full hover:bg-primary-default/50 items-center my-4"
          >
            Document toevoegen
          </button>
        </div>
      </div>
      <div class="no-padding" v-show="showUploadedFiles">
        <v-input-file-upload-compact
          :id="'file' + data.accountabilityId"
          :uploadedFilesData="licensePdfDetails"
          :accountabilityUpload="true"
          :allowedExtenstions="allowedFileExtenstions"
          :extensionErrorMessage="extensionErrorMessage"
          @file-added="showUploadedFileSection"
          @upload-success="saveUploadedFiles"
        ></v-input-file-upload-compact>
      </div>
      <v-table id="licensePdfDetails">
        <thead>
          <v-header-row :data="pdfTableHeaders" v-show="!showUploadedFiles"></v-header-row>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licensePdfDetails" :key="index" :class="{ fileUploadRow: !showUploadedFiles }">
            <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">
              {{ item.documentType }}
            </td>
            <td
              class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor underline cursor font-bold"
              @click="downloadLicensePdf(item)"
            >
              {{ item.fileName }}
            </td>
            <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor text-left">
              <v-delete-icon
                v-if="item.isDeletable"
                v-tooltip="{ content: 'Document verwijderen', placement: 'left', html: false }"
                @click.prevent="deleteAccountabilityPdf(item)"
              ></v-delete-icon>
            </td>
          </tr>
          <tr v-if="!licensePdfDetails || (licensePdfDetails && licensePdfDetails.length === 0)">
            <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor" colspan="3">
              Nog geen documenten toegevoegd. Voeg hier uw document toe om de machtiging compleet te maken.
            </td>
          </tr>
        </tbody>
      </v-table>
    </template>
    <template #footer>
      <v-button tagelement="button" hollow md transparent primary @click="closeModal()">Sluiten</v-button>
    </template>
  </generic-modal>
</template>

<script>
import router from '@/router';
import axios from 'axios';
import VActiveIcon from 'icons/CheckCircle';
import VDownloadIcon from 'icons/Download';
import VInputFileUpload from '@/components/shared/form/simple/InputFileUpload';
import VFileUploadIcon from 'icons/FileUploadOutline';
import VInputFileUploadCompact from '@/components/shared/form/simple/InputFileUploadCompact';
import VHeaderRow from '@/components/shared/table/rows/HeaderRow';
import VDeleteIcon from 'icons/Delete';
import VTable from '@/components/shared/table/Table';
import VCloseIcon from 'icons/CloseCircle';
import shared from '@/components/shared/shared';
import GenericModal from '@/components/shared/GenericModal';
import { currentUserIdentity$, getOsaOverviewDetails } from '@/services';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { ArrowDownTrayIcon } from '@heroicons/vue/20/solid';

export default {
  name: 'OsaDetailsRow',
  components: {
    ArrowDownTrayIcon,
    VActiveIcon,
    VDownloadIcon,
    VInputFileUpload,
    VCloseIcon,
    VFileUploadIcon,
    VInputFileUploadCompact,
    VHeaderRow,
    VTable,
    VDeleteIcon,
    GenericModal
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isLast: {
      type: Boolean
    }
  },
  setup() {
    const store = useStore();
    const user = ref(null);

    const saveAccountabilityFiles = (value) => store.dispatch('accountability/saveAccountabilityFiles', value);

    currentUserIdentity$.subscribe((value) => {
      user.value = value;
    });

    return {
      store,
      saveAccountabilityFiles,
      user
    };
  },
  data() {
    return {
      isExpanded: false,
      animated: false,
      osaRowOverviewDetails: {},
      osaPDF: null,
      showUploadedFiles: false,
      showPdfDetailsPopUp: false,
      licensePdfDetails: [],
      pdfTableHeaders: ['Document Type', 'Omschrijving', ''],
      allowedFileExtenstions: ['pdf', 'jpg', 'jpeg', 'png'],
      extensionErrorMessage:
        'Het geüploade document heeft niet de juiste extensie. U kunt alleen PDF, JPEG, JPG, of PNG documenten uploaden.'
    };
  },
  computed: {
    isApproved() {
      return this.osaRowOverviewDetails.IsApproved || this.osaRowOverviewDetails.IsReadyForApproval;
    },
    statusIcon() {
      return this.isApproved ? 'VActiveIcon' : 'VCloseIcon';
    },
    statusText() {
      return this.isApproved ? 'Therapie slaat aan' : 'Therapie slaat niet aan';
    }
  },
  created() {
    this.animated = true;
    setTimeout(() => {
      this.animated = false;
    }, 1000);
  },
  methods: {
    openFileInNewTab: shared.openFileInNewTab,
    fileExtention: shared.fileExtention,
    /**
     * @function toggle - Function to toggle the expand button
     */
    toggle() {
      if (!this.isExpanded) {
        this.fetchOSARowOverview();
      }
      setTimeout(() => {
        this.isExpanded = !this.isExpanded;
      }, 2000);
    },
    /**
     * @function fetchOSARowOverview - Fetch osa row overview
     */
    async fetchOSARowOverview() {
      let type = 'Evaluation';
      if (this.data.type === 'Uitlezing') {
        type = 'Readout';
      }
      this.osaRowOverviewDetails = await getOsaOverviewDetails({
        osaType: type,
        osaId: (type = 'Evaluation' ? this.data.osaEvaluationId : this.data.osaReadoutId),
        licenseId: 0
      });
    },
    /**
     * @function saveUploadedFiles - Function to upload file
     */
    saveUploadedFiles(fmData, licenceId, filetype) {
      let fileDetails = {
        licenseId: this.osaRowOverviewDetails.LicenseId,
        accountabilityId: this.osaRowOverviewDetails.AccountabilityId,
        documentType: filetype,
        formData: fmData
      };
      this.store
        .dispatch('accountability/saveAccountabilityFiles', fileDetails)
        .then((response) => {
          this.loadPdfDetails();
        })
        .catch((error) => {});
    },
    /**
     * @function getStatusClassName - Function to get class based on final Assesment
     */
    getStatusClassName(status) {
      switch (status) {
        case 'Doorgaan':
          return 'status-on';
        case 'Doorgaan na aanpassing(en)':
          return 'status-continue';
        case 'Stoppen':
          return 'status-stop';
        default:
      }
    },
    /**
     * @function getMoodRatioImage - Function to get mood image for rating
     */
    getMoodRatioImage(value) {
      return '/moodRatio' + value + '.svg';
    },
    /**
     * @function getVisibilityStatus - Function to show or not the installment details
     */
    getVisibilityStatus() {
      return (
        this.osaRowOverviewDetails &&
        this.osaRowOverviewDetails.IsSettingChangedFromOriginal &&
        this.isExpanded &&
        this.data.type === 'Evaluatie'
      );
    },
    // Marker comment
    /**
     * @function goToApproval - Function to redirect prescriber to approval form
     */
    goToApproval() {
      let type = 'Evaluation';
      if (this.data.type === 'Uitlezing') {
        type = 'Readout';
      }
      if (this.data.type === 'Evaluatie') {
        router.push('/osa/akkoordverklaring/' + type + '/' + this.data.osaEvaluationId);
      }
    },
    loadPdfDetails() {
      axios
        .post('Accountability/GetAllAccountabilityDocuments', {
          licenseId: this.osaRowOverviewDetails.LicenseId,
          accountabilityId: this.osaRowOverviewDetails.AccountabilityId,
          metaOnly: true
        })
        .then((response) => {
          if (response && response.data) {
            this.licensePdfDetails = response.data;
            this.showPdfDetailsPopUp = true;
          }
        });
    },
    async downloadLicensePdf(item) {
      if (item.document !== null) {
        this.downloadPdf({
          fileName: item.fileName,
          content: item.document
        });
        return;
      }
      axios
        .post('Accountability/GetSingleAccountabilityDocument', {
          documentGUID: item.documentGUID
        })
        .then((response) => {
          if (response && response.data) {
            this.downloadPdf({
              fileName: response.data.fileName,
              content: response.data.document
            });
          }
        });
    },
    downloadPdf(details) {
      const linkSource = `data:application/pdf;base64,${details.content}`;
      const downloadLink = document.createElement('a');
      const fileName = details.fileName;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      downloadLink.remove();
    },
    deleteAccountabilityPdf(item) {
      this.showPdfDetailsPopUp = false;
      // Start a promise, call for a prompt
      new Promise((resolve, reject) => {
        this.$emitter.emit('prompt', {
          title: 'Documenten verwijderen',
          message: 'U staat op het punt om document ' + item.fileName + ' definitief te verwijderen. Weet u het zeker?',
          resolve,
          reject
        });
      })
        .then((payload) => {
          // When prompt was confirmed
          axios
            .delete('Accountability/DeleteAccountabilityDocument', {
              params: {
                documentGUID: item.documentGUID,
                documentUUID: item.documentUUID
              }
            })
            .then((response) => {
              if (response && response.data) {
                this.$emitter.emit('alert', {
                  message: 'Document is succesvol verwijderd.',
                  type: 0
                });
                this.loadPdfDetails();
                this.showPdfDetailsPopUp = true;
              }
            })
            .catch(() => {
              this.$emitter.emit('alert', {
                message: 'Het verwijderen van dit document is niet gelukt. Probeer het later nogmaals.',
                type: 3
              });
              this.showPdfDetailsPopUp = true;
            });
        })
        .catch(() => {
          // When cancelled
          this.showPdfDetailsPopUp = true;
        });
    },
    openCompactFileUpload() {
      document.getElementById('file' + this.osaRowOverviewDetails.accountabilityId).click();
    },
    showUploadedFileSection(value) {
      this.showUploadedFiles = value;
    },
    closeModal() {
      this.showPdfDetailsPopUp = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.osa-details-row__status {
  &.status-on {
    background-color: $cyan-darker;
  }
  &.status-continue {
    background-color: $orange;
  }
  &.status-stop {
    background-color: $pure-red;
  }
}
.status-active {
  fill: $cyan-darker !important;
}
.status-inactive {
  fill: $pure-red !important;
}
</style>
